// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
const path = window.location.pathname.replace(/\/+$/, '');

if (path === '/emf/listen') {
  // Lazy-load listen page to keep main bundle clean
  const ListenPage = React.lazy(() => import('./listen/ListenPage'));
  root.render(
    <React.StrictMode>
      <React.Suspense fallback={
        <div style={{
          background: '#0a0f0a', color: '#00ffc8', height: '100vh',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontFamily: "'JetBrains Mono', monospace"
        }}>
          Loading...
        </div>
      }>
        <ListenPage />
      </React.Suspense>
    </React.StrictMode>
  );
} else {
  const App = React.lazy(() => import('./App'));
  root.render(
    <React.StrictMode>
      <React.Suspense fallback={null}>
        <App />
      </React.Suspense>
    </React.StrictMode>
  );
}
